<script lang="ts">
	import { Checkbox } from '$lib/components/atoms/Field';

  export let subscribe: boolean = false;
  export let businessUseConsent: boolean = false;
  export let profilingConsent: boolean = false;
  export let disabled: boolean = false;
  export let showPrivacy: boolean = false;

</script>
{#if showPrivacy}
  <div class="col-span-full mb-5">
    <h5 class="fs-6 mb-2">Presa visione dell’informativa privacy:</h5>
    <p class="text-gray-900 font-sans text-sm">
      Con l’invio della richiesta dichiaro di aver preso visione dell’<a href="/privacy-policy" target="_blank" class="font-normal underline">informativa privacy</a> e acconsento al trattamento dei dati personali forniti per l’erogazione del servizio richiesto o della risposta alla richiesta di informazioni.
    </p>
  </div>
{/if}
<Checkbox
  class="col-span-full"
  {disabled}
  bind:checked={subscribe}
>
  Attivando questa opzione, do il consenso a Digit’Ed S.p.A. al trattamento dei miei dati di contatto per
  finalità di marketing e comunicazione pubblicitaria, su iniziative promozionali, come invio di brochure, coupon
  sconto e promozioni.
  <a href="/privacy-policy">Leggi l'informativa</a>
</Checkbox>
<Checkbox
  class="col-span-full"
  {disabled}
  bind:checked={profilingConsent}
>
  Attivando questa opzione, do il consenso alla lettura dei dati di navigazione per effettuare attività di analisi e
  profilazione per migliorare l’offerta e i servizi in linea con le mie preferenze.
  <a href="/privacy-policy">Leggi l'informativa</a>
</Checkbox>
<Checkbox
  class="col-span-full"
  {disabled}
  bind:checked={businessUseConsent}
>
  Attivando questa opzione, do il consenso sull’utilizzo dei dati da parte di partner terzi per fini promozionali.
  <a href="/privacy-policy">Leggi l'informativa</a>
</Checkbox>
